import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Navbar from "../components/jobsiq/Navbar";
import Footer from "../components/jobsiq/Footer";
import JobCard from "../components/jobsiq/JobCard";
import { api } from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { toast } from "sonner";
import { BookmarkSimple, ArrowRight } from "@phosphor-icons/react";

export default function SavedJobs() {
    const { user } = useAuth();
    const nav = useNavigate();
    const [jobs, setJobs] = useState([]);
    const [loading, setLoading] = useState(true);

    const load = async () => {
        setLoading(true);
        try {
            const { data } = await api.get("/saved-jobs");
            setJobs(data);
        } catch (err) {
            toast.error(err?.response?.data?.detail || "Could not load saved jobs");
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => { load(); }, []);

    const toggleSave = async (job) => {
        try {
            if (job.is_saved) {
                await api.delete(`/saved-jobs/${job.job_id}`);
                setJobs((js) => js.filter((j) => j.job_id !== job.job_id));
                toast.success("Removed from saved");
            }
        } catch (err) {
            toast.error(err?.response?.data?.detail || "Action failed");
        }
    };

    const apply = async (job) => {
        try {
            await api.post(`/applications/${job.job_id}`);
            toast.success("Applied! Match scored by AI.");
            nav("/dashboard");
        } catch (err) {
            toast.error(err?.response?.data?.detail || "Apply failed");
        }
    };

    return (
        <div data-testid="saved-jobs-page">
            <Navbar />
            <section className="border-b border-slate-200">
                <div className="max-w-[1400px] mx-auto px-6 py-10">
                    <div className="font-mono-plex text-xs uppercase tracking-[0.3em] text-blue-600 mb-2 inline-flex items-center gap-1.5">
                        <BookmarkSimple size={14} weight="fill" /> Saved
                    </div>
                    <h1 className="font-display text-4xl">Roles you're keeping an eye on.</h1>
                    <p className="text-slate-600 mt-2">
                        {loading ? "Loading…" : `${jobs.length} saved role${jobs.length === 1 ? "" : "s"}`}
                    </p>
                </div>
            </section>
            <section className="max-w-[1400px] mx-auto px-6 py-8">
                {!loading && jobs.length === 0 ? (
                    <div className="border border-dashed border-slate-300 p-12 text-center">
                        <p className="text-slate-500 text-sm">
                            You haven't saved any jobs yet.
                        </p>
                        <Link
                            to="/jobs"
                            data-testid="browse-jobs-empty-cta"
                            className="mt-4 inline-flex items-center gap-1.5 text-sm bg-slate-950 text-white px-4 py-2 hover:bg-blue-600"
                        >
                            Browse jobs <ArrowRight size={14} />
                        </Link>
                    </div>
                ) : (
                    <div className="grid grid-cols-1 gap-4">
                        {jobs.map((j) => (
                            <JobCard
                                key={j.job_id}
                                job={j}
                                currentUser={user}
                                onApply={apply}
                                onToggleSave={toggleSave}
                            />
                        ))}
                    </div>
                )}
            </section>
            <Footer />
        </div>
    );
}
